import React, { useEffect, useState } from "react";
import { analysisAPI } from "../../utils/analysisAPI";
import MetricCard from "../../components/MetricCard";

function OrganisationIntelligence() {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const data = await analysisAPI.getOrganisationIntelligence();
        if (!mounted) return;
        setSummary(data);
        setError(null);
      } catch (e) {
        if (!mounted) return;
        setError(e.message || "Failed to load organisation intelligence.");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="analysis-dashboard">
      <div className="dashboard-header">
        <div className="header-content">
          <div>
            <h1>Organisation Intelligence</h1>
            <p className="subtitle">
              High-level health view based on your existing completed models.
            </p>
          </div>
        </div>
      </div>

      {error && (
        <div className="alert alert-error">
          <strong>Error:</strong> {error}
        </div>
      )}

      {loading || !summary ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Computing intelligence summary...</p>
        </div>
      ) : (
        <>
          <div className="stats-section">
            <MetricCard
              label="Health Score"
              value={summary.health_score}
              tone={
                summary.status === "Healthy"
                  ? "success"
                  : summary.status === "Moderate Risk"
                  ? "warning"
                  : "danger"
              }
              size="lg"
            />
            <MetricCard
              label="Total Analyses"
              value={summary.total}
              tone="primary"
            />
            <MetricCard
              label="Completed"
              value={summary.completed}
              tone="success"
            />
            <MetricCard
              label="Failed"
              value={summary.failed}
              tone="danger"
            />
          </div>

          <div className="results-grid">
            <div className="result-item">
              <div className="result-label">Status</div>
              <div className="result-value">{summary.status}</div>
            </div>
            <div className="result-item">
              <div className="result-label">Average Accuracy / R²</div>
              <div className="result-value">
                {typeof summary.avg_accuracy === "number"
                  ? `${(summary.avg_accuracy * 100).toFixed(1)}%`
                  : "Not available"}
              </div>
            </div>
            <div className="result-item">
              <div className="result-label">Failure Ratio</div>
              <div className="result-value">
                {(summary.failure_ratio * 100).toFixed(1)}%
              </div>
            </div>
            <div className="result-item">
              <div className="result-label">Anomaly Signals</div>
              <div className="result-value">
                {summary.anomaly_count} from {summary.anomaly_models || 0} model(s)
              </div>
            </div>
            {summary.revenue_trend && (
              <div className="result-item">
                <div className="result-label">Revenue Trend</div>
                <div className="result-value">
                  {summary.revenue_trend === "upward"
                    ? "Revenue trending upward"
                    : summary.revenue_trend === "downward"
                    ? "Revenue trending downward"
                    : "Revenue stable"}
                </div>
              </div>
            )}
          </div>

          {Array.isArray(summary.insights) && summary.insights.length > 0 && (
            <div className="result-section">
              <h3>Summary Insights</h3>
              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                {summary.insights.map((text, idx) => (
                  <li key={idx} style={{ marginBottom: "4px" }}>
                    {text}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default OrganisationIntelligence;

